import c from 'classnames';

import { useReactNodeView } from '@lyearn/lygo-core';
import { Checkbox, Stack } from '@lyearn/ui';

import { checkboxStyles } from './styles';

const CheckListItemEditable = () => {
  const { editableComponentRef } = useReactNodeView();
  return (
    <Stack className="mt-16">
      <Checkbox disabled className={c(checkboxStyles, 'mt-4 self-start')} variant="circle" />
      <div ref={editableComponentRef} className={'-mt-16 ms-16'} />
    </Stack>
  );
};

export default CheckListItemEditable;
